import React from "react";
import "./Contact.css";
import { HiOutlineMail } from "react-icons/hi";
import { ImWhatsapp } from "react-icons/im";
import { useRef } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
	const form = useRef();

	const sendEmail = (e) => {
		e.preventDefault();

		emailjs
			.sendForm(
				"service_18kskan",
				"template_jz56l8a",
				form.current,
				"YlmzJmi_c8Fs62f7A"
			)
			.then(
				e.target.reset()
			);
	};

	return (
		<section id="#contact" className="contact">
			<h5>Get In Touch</h5>
			<h2>Contact</h2>
			<div className="contact__container">
				<div className="contact__options">
					<article className="contact__option">
						<a href="mailto:Syntax-Read3r@gmail.com">
							<HiOutlineMail className="contact__icon" />
						</a>
						<h4>Email</h4>
						<h5>Syntax-Read3r@gmail.com</h5>
						<a href="mailto:Syntax-Read3r@gmail.com"> Send Email</a>
					</article>

					<article className="contact__option">
						<ImWhatsapp className="contact__icon" />
						<h4>WhatsApp</h4>
						<h5>+447763737670</h5>
						<a href="https://api.whatsapp.com/send?phone=+447763737670">
							Send a message
						</a>
					</article>
				</div>
				{/* End of Contact Option */}
				<form ref={form} onSubmit={sendEmail}>
					<input
						type="text"
						name="name"
						placeholder="Please Enter Your Full Name"
						required
					/>
					<input type="email" name="email" placeholder="Your Email" required />
					<textarea
						name="message"
						placeholder="Your Message."
						required
						rows="7"
					/>
					<button className="submitBtn btn btn-primary" type="submit">
						<span className="submitText">Send Message</span>
					</button>
				</form>
			</div>
		</section>
	);
};

export default Contact;
